import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=55cc59d1&scoped=true"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"
import style0 from "./TagPage.vue?vue&type=style&index=0&id=55cc59d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc59d1",
  null
  
)

export default component.exports